module.exports = __webpack_public_path__ + "static/img/day1.d87c76b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/day1.jpg
// module id = Hz4E
// module chunks = 0